/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react'
import { auth } from '../../../config/firebase'
import { signInWithEmailAndPassword } from 'firebase/auth'
import styles from './auth.module.scss'
import logo from '../../../assets/images/logoText.png'
import { useDispatch, useSelector } from 'react-redux'
import { login, signUp } from '../../../Redux/auth/authSlice'

const Auth = () => {
  const dispatch = useDispatch() // Use the Redux dispatch function
  const { loading, error, user } = useSelector((state) => state.auth)
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')

  const handleSignIn = () => {
    if (!email || !password) return
    dispatch(login({ email, password })) // Dispatch the login action with email and password
  }

  return (
    <div className={styles.authContainer}>
      <div className={styles.leftImage}></div>
      <div className={styles.loginForm}>
        <form>
          <img alt='logo' src={logo} />
          <ul>
            <li>
              <label htmlFor='email'>Email</label>
              <input type='email' placeholder='Email...' onChange={(e) => setEmail(e.target.value)} />
            </li>
            <li>
              <label htmlFor='password'>Password</label>
              <input type='password' id='password' placeholder='Password...' onChange={(e) => setPassword(e.target.value)} />
            </li>
          </ul>
          <button type='button' onClick={handleSignIn}>
            Sign In
          </button>
        </form>
      </div>
    </div>
  )
}

export default Auth
